import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const SubscriptionsAndUsage = lazy(() =>
  import("@scenes/SubscriptionsAndUsage").then((module) => ({
    default: module.SubscriptionsAndUsage,
  }))
);

export const billingNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("billing-sidebar-pill-menu-option", "Billing"),
  pageNameForTracking: () => "Billing",
  Component: SubscriptionsAndUsage,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    // Please keep this in sync with the logic in the SettingsMenuItems component
    return hasPermission("appGroup", {
      permission: "viewBilling",
    });
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("billing-alt-keyword-1", "MAU"),
        t("billing-alt-keyword-2", "MUV"),
        t("billing-alt-keyword-3", "Email sends"),
        t("billing-alt-keyword-4", "Contact details"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
